import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

// TNK-177 — top-level single-segment catch-all. Static routes (/dashboard,
// /lots, /shop, …) take precedence, so this only matches otherwise-unknown
// segments. It also only ever RENDERS when signed in: __root's DoorResolver
// short-circuits signed-out paths before routing (the operator login at the
// secret door slug is handled entirely there). So when an authenticated
// operator hits their door slug (or any unknown path), send them to the
// dashboard rather than 404.
export const Route = createFileRoute("/$door")({
  component: DoorRedirect,
});

function DoorRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({ to: "/dashboard", replace: true });
  }, [navigate]);
  return (
    <div className="mx-auto max-w-md py-12 text-center text-muted-foreground">
      <Loader2 size={20} className="mx-auto animate-spin" />
      <p className="mt-3 text-sm">Redirecting…</p>
    </div>
  );
}
